import React from 'react'
import PropTypes from 'prop-types'

function AnalysisIcon({ height, width, fill }) {
	return (
		<svg fill={fill} height={height} width={width} viewBox="0 0 1200 1200" xmlns="http://www.w3.org/2000/svg">
			<path d="m1069.7 854.34-185.63-185.16 0.046875-0.46875c66.844-152.44 37.406-336.61-86.953-460.97-162.71-162.71-426.84-162.71-589.08 0-163.18 162.71-163.18 426.37 0 589.55 124.36 124.36 308.58 153.32 460.97 86.953l185.63 185.16c59.391 59.859 155.21 59.859 215.06 0 59.344-58.922 59.344-155.21-0.046875-215.06zm-350.26-301.03h-82.031c-13.5 0-26.203-6.375-34.312-17.156l-28.547-38.109-82.781 122.72c-7.7812 11.531-20.625 18.562-34.453 18.891h-1.0781c-13.453 0-26.203-6.3281-34.312-17.156l-51.844-69.188h-68.531c-23.672 0-42.844-19.172-42.844-42.844s19.172-42.844 42.844-42.844h90c13.5 0 26.203 6.375 34.312 17.156l28.547 38.109 82.781-122.72c7.7812-11.531 20.625-18.562 34.453-18.891 13.781-0.375 27.047 6.0469 35.344 17.156l51.844 69.188h60.562c23.672 0 42.844 19.172 42.844 42.844 0.046875 23.625-19.172 42.844-42.797 42.844z"/>
		</svg>
	)
}

AnalysisIcon.propTypes = {
	height: PropTypes.string,
	width: PropTypes.string,
	fill: PropTypes.string,
}

AnalysisIcon.defaultProps = {
	width: '2em',
	height: '2em',
	fill: '#000000',
}

export default AnalysisIcon


